import type { HTMLAttributes } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  hover?: boolean;
}

/** Базовая карточка с радиусом 12 и опциональным hover-shadow. */
export function Card({ hover = false, className = '', ...rest }: CardProps) {
  return (
    <div
      {...rest}
      className={[
        'bg-white border border-border rounded-card',
        hover && 'hover:border-ink/20 hover:shadow-card-hover transition-all cursor-pointer',
        className,
      ].filter(Boolean).join(' ')}
    />
  );
}
